module.exports = __webpack_public_path__ + "components/rewards/stanford-skiing/static/logo-a5421e6ff49527de6d4430608f016517.jpg";